import type { ReactNode } from 'react';

import { bold, InlineText, TimelineEvent } from '../components/shared';
import { TIMELINE_DESIGN_TOKENS } from '../design-tokens';
import type { WebhookOutcomePayload } from '../types';
import type { EventComponentProps } from './types';

const META_TEXT_CLASS = `${TIMELINE_DESIGN_TOKENS.typography.subItem} text-secondary`;

export function WebhookDeliveredEvent({ event }: EventComponentProps) {
  const payload = event.payload as WebhookOutcomePayload | undefined;

  const durationMs = payload?.duration_ms;
  const durationFragment =
    durationMs !== undefined && Number.isFinite(durationMs)
      ? `Delivered in ${durationMs} ms`
      : null;

  const attemptCount = payload?.attempt_count;
  const attemptFragment =
    attemptCount !== undefined && Number.isFinite(attemptCount)
      ? `${attemptCount} attempt(s)`
      : null;

  const metaParts = [durationFragment, attemptFragment].filter(Boolean);
  const meta: ReactNode =
    metaParts.length > 0 ? (
      <div className={META_TEXT_CLASS}>{metaParts.join(' · ')}</div>
    ) : null;

  return (
    <TimelineEvent ariaLabel='Webhook delivered'>
      <TimelineEvent.Icon event={event} />
      <TimelineEvent.Content
        eventId={event.event_id}
        header={<InlineText>{bold('Webhook delivered')}</InlineText>}
        timestamp={event.occurred_at}
      >
        {meta}
      </TimelineEvent.Content>
    </TimelineEvent>
  );
}
